import { useDispatch } from 'react-redux';
import { actions } from './index';

export const useNotifications = () => {
  const dispatch = useDispatch();

  return {
    create: (notification) => dispatch(actions.create(notification)),
  };
};
